import { z } from "zod";

export const alertBaseSchema = z.object({
  id: z.string(),
  titulo: z.string(),
  email: z.string(),
  telefone: z.string(),
  uf: z.string(),
  cidades: z.string().nullable(),
  endereco: z.string().nullable(),
  bairros: z.string().nullable(),
  area: z.number().nullable(),
  dias_faltantes_leilao: z.number().nullable(),
  tipo: z.string().nullable(),
  modalidade_de_venda: z.string().nullable(),
  pagamento: z.string().nullable(),
  preco_min: z.number().nullable(),
  preco_max: z.number().nullable(),
  desconto: z.number().nullable(),
});

export const alertSchema = alertBaseSchema.extend({
  modalidade_de_venda: z
    .string()
    .nullable()
    .transform((val) => val?.split(",") || []),
  pagamento: z
    .string()
    .nullable()
    .transform((val) => val?.split(",") || []),
});

export const alertsSchema = z.array(alertBaseSchema);
